import React from 'react'
import useLayersManager from './useLayersManager'
import useIntegerZoom from './useIntegerZoom'
import useMapZoomHandler from '../useMapZoomHandler'
import useMapMoveHandler from '../useMapMoveHandler'
import useMapPaddingHandler from '../useMapPaddingHandler'
import LayersButtons from '../common/LayersButtons'

const RasterMap = () => {
  useLayersManager()
  useIntegerZoom()
  useMapMoveHandler()
  useMapZoomHandler()
  useMapPaddingHandler()

  return (
    <>
      <LayersButtons />
    </>
  )
}

export default RasterMap
